import { useContext } from 'react'
import { AdVehicleStreamContext } from './AdVehicleStreamProvider'

export const useAdVehicleStream = () => {
  const AdVehicleStreamValue = useContext(AdVehicleStreamContext)

  if (!AdVehicleStreamValue) {
    throw new Error(
      'useAdVehicleStream must be used within a AdVehicleStreamProvider',
    )
  }

  return AdVehicleStreamValue
}
